var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBeltSpeed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 19,
    viewBox: "0 0 23 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.4994 0C17.8508 0 23 5.10202 23 11.3964C23 14.0375 22.0927 16.4674 20.5719 18.4L18.9177 16.7321C20.0168 15.2336 20.6655 13.3903 20.6655 11.3963C20.6655 6.37944 16.5618 2.31293 11.4995 2.31293C6.43725 2.31293 2.3344 6.37944 2.3344 11.3963C2.3344 13.3902 2.98263 15.2336 4.08135 16.7321L2.42736 18.4C0.906152 16.4673 0 14.0374 0 11.3964C0 5.10202 5.14822 0 11.4996 0H11.4994ZM12.7027 11.2638C13.4689 11.6851 13.9871 12.493 13.9871 13.4207C13.9871 14.7815 12.8731 15.8859 11.4996 15.8859C10.1265 15.8859 9.01135 14.7815 9.01135 13.4207C9.01135 12.4931 9.5296 11.6853 10.2957 11.2638L11.4996 4.76992L12.7029 11.2638H12.7027Z",
    fill: "#6DBFFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBeltSpeed);
export default __webpack_public_path__ + "static/media/beltSpeed.ce1f6f0db7de50c39eb8f7db8438ac73.svg";
export { ForwardRef as ReactComponent };